import { colors } from "common/const/colors";
import React, {
  createContext,
  forwardRef,
  useContext,
  useImperativeHandle,
  useState,
} from "react";
import styled from "styled-components";
import { boxShadowS } from "../Style/shadowStyle";

const ModalBackground = styled.div`
  display: flex;
  position: fixed; /* position 수정 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.4); /* 백그라운드 투명도 추가 */
`;

const ModalPopupCard = styled.div`
  display: flex;
  ${boxShadowS}
  background-color: ${colors.White};
  border-radius: 20px;
  padding: 1.5rem;
  padding-top: 2rem;
`;

const ModalContext = createContext();

export const ModalProvider = forwardRef(({ children }, ref) => {
  const [modals, setModals] = useState([]);

  const openModal = (props = {}) => {
    const id = Date.now();
    setModals((prev) => [...prev, { id, blockOuter: false, ...props }]);
    return id;
  };

  const closeModal = (id) => {
    setModals((prev) => prev.filter((modal) => modal.id !== id));
  };

  // 외부 ref에서 openModal, closeModal 접근 가능하게 expose
  useImperativeHandle(ref, () => ({
    openModal,
    closeModal,
  }));

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {modals.map((modal) => (
        <ModalBackground
          key={modal.id}
          onClick={() => {
            if (!modal.blockOuter) {
              modal.onOuterClick?.();
              closeModal(modal.id);
            }
          }}>
          <ModalPopupCard onClick={(e) => e.stopPropagation()}>
            {modal.content}
          </ModalPopupCard>
        </ModalBackground>
      ))}
      {children}
    </ModalContext.Provider>
  );
});

export const useModal = () => useContext(ModalContext);
